import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";
import RestaurantPreference from "../../enums/restaurant-preference.ts";

export default class V1GroupRestaurantCategoryPreferences extends BaseOutgoingPayload {
  public readonly payload: V1GroupRestaurantCategoryPreferencesPayload;

  constructor(restaurantCategoryPreferences: Record<string, RestaurantPreference>) {
    super(OutgoingPayloadEvent.V1_GROUP_RESTAURANT_CATEGORY_PREFERENCES);
    this.payload = new V1GroupRestaurantCategoryPreferencesPayload(restaurantCategoryPreferences);
  }
}

class V1GroupRestaurantCategoryPreferencesPayload {
  public readonly restaurant_category_preferences: Record<string, RestaurantPreference>;

  constructor(restaurant_category_preferences: Record<string, RestaurantPreference>) {
    this.restaurant_category_preferences = restaurant_category_preferences;
  }
}
